import React from 'react';

import { Aperitivi, Caffetteria, Contacts, Footer, Header, PausaPranzo } from './container';
import { Navbar } from './components';

const App = () => (
  <>
    <a href="#contenuto" className="skip-link">
      Vai al contenuto
    </a>
    <Navbar />
    <main id="contenuto">
      <Header />
      <Caffetteria />
      <PausaPranzo />
      <Aperitivi />
      <Contacts />
    </main>
    <Footer />
  </>
);

export default App;
